export function set_position(el, dest, x = .8, y = .5) {
    const src_rect = el.getBoundingClientRect()
        , dest_rect = dest.getBoundingClientRect()
        , pos_x = src_rect.x + window.scrollX - (dest_rect.width * x)
        , pos_y = src_rect.y + window.scrollY - (dest_rect.height * y)
    dest.style.left = `${pos_x}px`
    dest.style.top = `${pos_y}px`
    dest.style.position = 'absolute'
}